/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2026-10-29 09:05:19.

export class ReportFieldMxObj implements Serializable {
    name: string;
    label: string;
    type: string;
    required: boolean;
    collapsed: boolean;
    filter: boolean;
    internal: boolean;
    dateTimeFormat: string;
    jsDateTimeFormat: string;
    precision: number;
    value: string;
    values: IdNameMxObj[];
    sublist: ReportFieldMxObj[];
}

export class DisabledObj {
    isDisabled: boolean;
    hint: string;
}

export class IdToOrderObj {
    id: any;
    order: number;
}

export class AgentDetailsObj {
    userName: string;
    firstName: string;
    lastName: string;
    agentEmail: string;
    phone: string;
    msTeams: string;
    status: string;
    reportsTo: string;
    roles: string;
    teams: string;
    passwordUpdateRequired: boolean;
    daysToUpdatePassword: number;
}

export class ApiKeyMetadataObj {
    id: number;
    keyValue: string;
    createdOn: Date;
    expiresOn: Date;
    expiringSoon: boolean;
    expired: boolean;
}

export class ChangePasswordObj {
    id: number;
    oldPassword: string;
    password: string;
}

export class ChangePasswordPrlObj {
    id: number;
    oldPassword: string;
    password: string;
}

export class ResetPasswordObj {
    username: string;
    email: string;
    newPassword: string;
    token: string;
}

export class UpdatePasswordPrlObj {
    password: string;
}

export class AffiliateToAdminPkObj {
    affiliateId: number;
    adminId: number;
}

export class AgentObj {
    id: number;
    userName: string;
    statusId: number;
    lastLoginDate: Date;
    firstName: string;
    lastName: string;
    reportsTo: KeyValueObj;
    phone: string;
    msTeams: string;
    agentEmail: string;
    password: string;
    comment: string;
}

export class ApplicationPropertyObj {
    id: number;
    key: string;
    value: string;
    description: string;
}

export class ConfigurationGroupObj {
    dataObj: UiDataObj;
    values: { [index: string]: any };
    label: string;
}

export class ConfigurationObj {
    groups: ConfigurationGroupObj[];
}

export class LanguageObj {
    id: number;
    name: string;
    code: string;
}

export class PermissionObj {
    id: number;
    label: string;
    name: string;
    availableActions: AvailableAction[];
    roleActions: AvailableAction[];
    children: PermissionObj[];
}

export class ProductTypeObj {
    id: number;
    name: string;
    order: number;
    description: string;
}

export class PromotionTypeObj {
    id: number;
    name: string;
    description: string;
}

export class PtSyncAdminObj {
    id: number;
    name: string;
    adminUrl: string;
    systemId: number;
    advSysName: string;
    advGroupName: string;
    isSyncEnabled: boolean;
}

export class ResponseRequestObj {
    response: string;
    request: string;
}

export class RoleObj {
    id: number;
    name: string;
    permissions: PermissionObj;
    description: string;
}

export interface RolePermissionObj {
    permissionId: number;
    name: string;
    actions: number;
}

export class TeamObj {
    id: number;
    name: string;
    description: string;
}

export class TrafficSourceObj {
    id: number;
    name: string;
    description: string;
}

export class ContentParamObj {
    name: string;
    type: string;
    description: string;
    value: string;
}

export class CreativeContentObj {
    content: ContentObj;
    stringContent: string;
    params: ContentParamObj[];
    readonly: boolean;
    height: number;
    width: number;
}

export class CreativeObj {
    id: number;
    productId: number;
    name: string;
    statusId: number;
    typeId: number;
    subTypeId: number;
    promotionTypeId: number;
    languageCode: string;
    currencyCode: string;
    basedPromo: KeyValueObj;
    createdOn: Date;
    updatedOn: Date;
    hasThumb: boolean;
    thumbNailClass: string;
    description: string;
}

export class NewCreativeObj {
    id: number;
    productId: number;
    merchantId: number;
    name: string;
    statusId: number;
    typeId: number;
    subTypeId: number;
    promotionTypeId: number;
    languageCode: string;
    currencyCode: string;
    basedPromo: KeyValueObj;
    defaultLandingPage: KeyValueObj;
    autoCreateZone: boolean;
    merchantCampaign: number;
    zoneName: string;
    affiliate: KeyValueObj;
    description: string;
    content: ContentObj;
}

export class CreativeSubTypeObj {
    id: number;
    creativeTypeId: number;
    name: string;
    width: number;
    height: number;
    templateId: number;
    templateName: string;
    description: string;
}

export interface CreativeTypeBlobObj {
    fileType: string;
    content: any;
}

export class CreativeTypeObj {
    id: number;
    name: string;
    templateId: number;
    editorTypeId: number;
    hasThumb: boolean;
    description: string;
}

export class PortalNotificationObj {
    id: number;
    title: string;
    active: boolean;
    mandatory: boolean;
    message: string;
    createdBy: Date;
    createdOn: string;
}

export class TermsAndConditionsObj {
    id: number;
    version: string;
    value: string;
    updatedOn: Date;
    updatedBy: string;
    description: string;
}

export class CountryIsoObj {
    code: string;
    name: string;
}

export class CurrencyIsoObj {
    code: string;
    name: string;
    inUse: boolean;
}

export class LanguageIsoObj {
    code: string;
    name: string;
}

export class PortalDesignObj {
    labelId: number;
    labelName: string;
    value: string;
}

export class PortalLabelContentObj {
    id: number;
    labelId: number;
    labelName: string;
    languageCode: string;
    value: string;
}

export class PortalLabelObj {
    name: string;
    keepHistory: boolean;
    html: boolean;
}

export class PortalLanguageObj {
    code: string;
    name: string;
    orderCol: number;
    default: boolean;
}

export class PortalPageObj {
    id: number;
    name: string;
    enabled: boolean;
    editable: boolean;
}

export class TopZoneObj {
    zoneId: number;
    zoneName: string;
    promoOrder: number;
    description: string;
}

export class AffiliateTagObj {
    id: number;
    name: string;
    typeId: number;
}

export class TagObj {
    id: number;
    name: string;
}

export class AssignmentTagObj extends TagObj {
    typeName: string;
}

export class ColorTagObj {
    id: number;
    name: string;
    typeId: number;
    color: string;
}

export class CreativeTagObj extends TagObj {
    typeId: number;
    typeName: string;
}

export class TaxObj {
    id: number;
    startDate: Date;
    user: string;
    createdDate: Date;
    updateDate: Date;
    description: string;
}

export class AdminCommissionObj extends TaxObj {
    productTypeId: number;
    commissionRate: number;
}

export class CountryTaxObj extends TaxObj {
    countryIsoCode: string;
    productTypeId: number;
    rate: number;
}

export class TaxConfigObj extends TaxObj {
    type: number;
}

export class VatRateObj extends TaxObj {
    commissionRate: number;
}

export class TemplateObj {
    id: number;
    typeId: number;
}

export class EmailTemplateObj extends TemplateObj {
    templateId: number;
    language: string;
    subject: string;
    body: string;
    description: string;
}

export class ICTemplateObj extends TemplateObj {
    name: string;
    templateId: number;
    content: string;
    description: string;
}

export class TemplateVariableObj {
    placeholder: string;
    description: string;
}

export class AffiliateCheckboxGroupObj {
    kyc: boolean;
    sendPromotion: boolean;
    messageEmailNotifier: boolean;
    majorTermsAndConditionAccepted: boolean;
    vatPayer: boolean;
}

export class AffiliateMarketingInfoObj {
    numberOfSites: string;
    gamblingOriented: boolean;
}

export class AffiliateObj {
    userName: string;
    statusId: number;
    vipLevel: string;
    id: number;
    owner: KeyValueObj;
    company: string;
    companyId: string;
    taxId: string;
    languageCode: string;
    countryCode: string;
    parentAffiliate: KeyValueObj;
    lastLoginDate: Date;
    currentEarnings: number;
    cookieDuration: number;
    signupDate: Date;
    loginCount: number;
    termsAndContidionVersion: string;
    paymentAffiliate: KeyValueObj;
    paymentStatusId: number;
    comment: string;
    sendPromotion: boolean;
    messageEmailNotifier: boolean;
    majorTermsAndConditionAccepted: boolean;
    vatPayer: boolean;
    kyc: boolean;
}

export class AffiliateWebsiteObj {
    id: number;
    affiliateId: number;
    website: string;
}

export class BoSubAffiliateHistoryObj {
    updatedDate: Date;
    action: string;
    affiliateUserName: string;
    updatedUser: string;
}

export class ContactObj {
    id: number;
    userId: number;
    firstName: string;
    lastName: string;
    homePhone: string;
    mobilePhone1: string;
    mobilePhone2: string;
    workPhone1: string;
    workPhone2: string;
    fax: string;
    email: string;
    msTeams: string;
    address1: string;
    address2: string;
    country: string;
    city: string;
    contactType: number;
    contactTypeName: string;
    zip: string;
    state: string;
}

export class NewAffiliateCheckBoxGroupObj {
    kyc: boolean;
    sendPromotion: boolean;
    messageEmailNotifier: boolean;
    vatPayer: boolean;
}

export class NewAffiliateObj {
    id: number;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    statusId: number;
    password: string;
    vipLevel: string;
    owner: KeyValueObj;
    company: string;
    companyId: string;
    taxId: string;
    website: string;
    languageCode: string;
    countryCode: string;
    signupDate: Date;
    products: string;
    comment: string;
    sendPromotion: boolean;
    messageEmailNotifier: boolean;
    vatPayer: boolean;
    kyc: boolean;
}

export class PortalNewAffiliateObj {
    firstName: string;
    lastName: string;
    email: string;
    userName: string;
    password: string;
    website: string;
    company: string;
    homePhone: string;
    msTeams: string;
    address1: string;
    address2: string;
    companyId: string;
    languageCode: string;
    countryCode: string;
    taxId: string;
    state: string;
    productOfInterestIds: string;
    productIds: string;
    messageEmailNotifier: boolean;
    vatPayer: boolean;
    sendPromotions: boolean;
    majorTermsAndConditionAccepted: boolean;
    referrer: string;
}

export class ProductAccessObj {
    id: number;
    name: string;
    merchant: string;
    typeName: string;
}

export class SourceVariableObj {
    id: number;
    objectId: number;
    name: string;
    value: string;
    finalValue: boolean;
    toEncode: boolean;
}

export class SubAffiliatesDetailsObj {
    referrerUrl: string;
    allowSubAffiliates: boolean;
}

export class BaseDocument {
    id: number;
    affiliateId: number;
    name: string;
    creationDate: Date;
    showInPortal: boolean;
    description: string;
    uploadedBy: string;
}

export class DocumentInfoObj extends BaseDocument {
}

export class DocumentObj extends BaseDocument {
    content: ContentObj;
}

export class CampaignObj {
    id: number;
    userId: number;
    name: string;
    statusId: number;
    stateId: number;
    startDate: Date;
    endDate: Date;
    isDefault: boolean;
    dealId: number;
    description: string;
}

export class CampaignProfileObj {
    id: number;
    campaignId: number;
    name: string;
    url: string;
    trafficSourceId: number;
    createdOn: Date;
    description: string;
}

export class BadgesObj {
    newMessages: number;
    newAffiliates: number;
    pendingPaymentAccounts: number;
    pendingWithdrawalRequest: number;
}

export class KeySearchResultObj {
    decodedKey: string;
    campaignName: string;
    campaignId: number;
    profileName: string;
    profileId: number;
    affiliateName: string;
    affiliateId: number;
    zoneName: string;
    zoneId: number;
    landingPageName: string;
    landingPageId: number;
    merchantId: number;
    productId: number;
    var1: string;
    var2: string;
    var3: string;
    var4: string;
    var5: string;
    var6: string;
    var7: string;
    var8: string;
    var9: string;
    var10: string;
}

export class RerunObj {
    startDate: Date;
    createdAt: Date;
    startedAt: Date;
    finishedAt: Date;
    status: string;
}

export class DealExportObj {
    id: number;
    masterId: number;
    prePreset: string;
    postPreset: string;
    type: string;
    dealLines: DealLineExportObj[];
    startDate: Date;
}

export class DealGraphObj {
    id: number;
    startDate: Date;
    endDate: Date;
}

export class DealLineExportObj {
    minCount: number;
    maxCount: number;
    costPerUnit: number;
    progressive: boolean;
    groupId: number;
    formula: string;
    priority: number;
    filter: string;
    units: number;
    id: number;
    tracker: string;
    tagId: number;
}

export class DealLineObj {
    id: number;
    trackerId: number;
    trackerName: string;
    minCount: number;
    maxCount: number;
    costPerUnit: number;
    progressive: boolean;
    invisible: boolean;
    groupId: number;
    formula: number;
    priority: number;
    filter: FilterObj;
    units: number;
    colorTag: ColorTagObj;
}

export class DealLinesObj {
    dealLines: DealLineObj[];
}

export class DealObj {
    id: number;
    masterId: number;
    prePreset: DealPresetObj;
    postPreset: DealPresetObj;
    dealTypeId: number;
    campaignId: number;
    affiliateId: number;
    dealLines: DealLinesObj;
    startDate: Date;
}

export class DealPresetExportObj {
    name: string;
    type: string;
    dealLines: DealLineExportObj[];
}

export class DealPresetObj {
    id: number;
    name: string;
    masterId: number;
    dealTypeId: number;
    fieldPreset: KeyValueObj;
    hiddenPreset: boolean;
    active: boolean;
    dealLines: DealLinesObj;
    startDate: Date;
}

export class CloseWarningsObj {
    ids: number[];
    note: string;
}

export class LoadedFileObj {
    requestType: string;
    request: string;
    body: string;
}

export class ProductAliasEditObj {
    id: number;
    alias: string;
    productId: number;
}

export class ProductAliasViewObj {
    id: number;
    alias: string;
    product: string;
}

export class RerunRequestObj {
    typeId: number;
    startDate: Date;
    description: string;
}

export class ComplexValidationObj {
    nested1: ExpensiveCheckObj;
}

export class ExpensiveCheckObj {
    firstCheck: string;
    secondCheck: string;
    thirdCheck: string;
    fourthCheck: string;
}

export interface Order {
}

export interface Create extends Create1, Create2, Create3 {
}

export interface Create1 {
}

export interface Create2 {
}

export interface Create3 {
}

export interface CreateSequential {
}

export interface Edit extends Edit1, Edit2, Edit3 {
}

export interface Edit1 {
}

export interface Edit2 {
}

export interface Edit3 {
}

export interface EditSequential {
}

export class FieldObj {
    id: number;
    name: string;
    reportName: string;
    action: string;
    description: string;
}

export class FieldPresetObj {
    id: number;
    name: string;
}

export class PortalFieldObj {
    include: number[];
    exclude: number[];
}

export class FilterNodeObj {
    type: "empty" | "group" | "rule";
}

export class EmptyNodeObj extends FilterNodeObj {
    type: "empty";
}

export class FilterObj {
    id: number;
    name: string;
    filterData: FilterNodeObjUnion;
}

export class GroupNodeObj extends FilterNodeObj {
    type: "group";
    childs: FilterNodeObjUnion[];
    groupType: string;
    groupDifference: KeyValueObj[];
}

export class OperatorDetailsObj {
    key: FilterOperator;
    name: string;
    operandsNumber: number;
    basicOperator: boolean;
    comparableOperator: boolean;
    stringOperator: boolean;
}

export class RuleNodeObj extends FilterNodeObj {
    type: "rule";
    ruleInfo: RuleReaderInfoObj;
}

export class RuleReaderInfoObj {
    variable: string;
    subVariable: string;
    operator: FilterOperator;
    operands: string[];
    difference: KeyValueObj[];
}

export class TrackerVariableObj {
    name: string;
    type: VariableType;
    operandType: string;
}

export class ApproveAllObj {
    transactionHandlerObj: TransactionHandlerObj;
    requestObj: ReportRequestObj;
}

export class CloseMonthObj {
    jobId: number;
    period: Date;
    status: EarningProcessMonthlyStatus;
}

export class EditPaymentAccountPrlObj {
    paymentMethod: string;
    isDefault: boolean;
    status: string;
}

export class NewPaymentAccountObj {
    affiliate: KeyValueObj;
    paymentMethod: string;
    comments: string;
    isDefault: boolean;
}

export class NewPaymentAccountPrlObj {
    paymentMethod: string;
    isDefault: boolean;
}

export class NewTransactionObj {
    affiliateId: number;
    userName: string;
    merchantId: number;
    merchantName: string;
    typeId: number;
    period: Date;
    name: string;
    description: string;
    amount: number;
    idNumber: number;
    vatNumber: string;
    paymentAccountId: string;
}

export class NewWithdrawalPrlObj {
    affiliateId: number;
    merchantId: number;
    amount: number;
    idNumber: number;
    paymentAccountId: string;
    description: string;
    vatPayer: boolean;
    vatNumber: string;
}

export class PayingCompanyObj {
    id: number;
    name: string;
    isDefault: boolean;
    isActive: boolean;
    description: string;
    active: boolean;
    default: boolean;
}

export class PaymentAccountObj {
    id: number;
    userId: number;
    name: string;
}

export class PaymentMethodsCurrencyObj {
    code: string;
    name: string;
}

export class TransactionHandlerLineObj {
    id: number;
    updatedId: number;
    typeId: number;
}

export class TransactionHandlerObj {
    period: Date;
    name: string;
    executeDate: Date;
    referenceNumber: string;
    payingCompanyId: number;
    description: string;
    status: string;
    lines: TransactionHandlerLineObj[];
}

export class TransactionObj {
    id: number;
    affiliateId: number;
    period: Date;
    affiliateName: string;
    merchantId: number;
    merchantName: string;
    typeId: number;
    name: string;
    statusId: number;
    amount: number;
    description: string;
    paymentAccountId: string;
    identificationNumber: number;
    vatNumber: string;
    createdOn: Date;
    updatedOn: Date;
    paymentReference: string;
    executionTime: Date;
    payingCompanyId: number;
    payingCompanyName: string;
    openingBalance: number;
    liabilities: number;
    endingBalance: number;
    updatedUserId: number;
    updatedUser: string;
    updatedId: number;
}

export class TransactionSearchTypeObj {
    id: number;
    name: string;
    status: string;
}

export class TransactionTypeObj {
    id: number;
    name: string;
    creatable: boolean;
    nonPayableCreatable: boolean;
    balanceEffect: number;
    allowNegative: boolean;
    amountRestriction: number;
    liabilities: boolean;
    creditOrDebit: boolean;
}

export class TransactionTypeSelectionObj {
    typeId: string;
}

export class UpdatePaymentAccountPrlObj {
}

export class UpdateSecureObj {
    id: number;
    secureId: string;
}

export class ViewPaymentAccountObj {
    id: number;
    affiliate: string;
    paymentMethod: string;
    isDefault: boolean;
    comments: string;
    properties: { [index: string]: any };
}

export class WithdrawalEmailObj {
    messageType: number;
    transactionId: number;
    subject: string;
    body: string;
}

export class JobInfoObj {
    id: string;
    status: JobStatus;
    processedRows: number;
    totalRows: number;
    message: string;
}

export class ContentObj {
    name: string;
    type: string;
    data: any;
}

export class MassImportJobInfoObj extends JobInfoObj {
    importResult: MassImportResultObj;
}

export class MassImportResultObj {
    success: boolean;
    message: string;
    errorFile: ContentObj;
}

export class MassUploadTypeObj {
    name: string;
    type: string;
    paymentMethod: string;
    file: ContentObj;
}

export class MerchantInfoObj {
    id: number;
    symbol: string;
    address: string;
    zipCode: string;
    countryCode: string;
    phone: string;
    idNumber: string;
    vatNumber: string;
    merchantEmail: string;
}

export class MerchantObj {
    id: number;
    userName: string;
    company: string;
    languageCode: string;
    countryCode: string;
    statusId: number;
    ownerAgentId: number;
    signupDate: Date;
    comment: string;
}

export class AgentEmailTemplateObj {
    id: number;
    agentId: number;
    name: string;
    description: string;
    subject: string;
    body: string;
}

export class EmailDetailsObj {
    subject: string;
    scheduledDate: number;
    sendDate: number;
    body: string;
    receivers: string;
}

export class MailingListAffiliateObj {
    id: number;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
}

export class MailingListObj {
    id: number;
    agentId: number;
    dynamic: boolean;
    name: string;
    description: string;
    affiliates: MailingListAffiliateObj[];
    filter: ReportUiDataObj[];
}

export class MessageLineObj {
    id: number;
    user: string;
    date: number;
    message: string;
    status: string;
    userSend: boolean;
}

export class MessageObj {
    messageChainId: number;
    messageSubChainId: number;
    subject: string;
    global: boolean;
    lines: MessageLineObj[];
}

export class NewEmailToAffiliateObj {
    recipients: number[];
    mailingLists: number[];
    emailSubject: string;
    emailBody: string;
    description: string;
    deliveryDate: Date;
}

export class NewMessageObj {
    type: MessageTypes;
    subject: string;
    startDate: Date;
    endDate: Date;
    recipients: string;
    message: string;
}

export class ReadMessageObj {
    id: number;
    affiliateId: number;
    affiliateName: string;
    subject: string;
    message: string;
    global: boolean;
}

export class RevokeReadMessageAffiliateObj {
    subChainId: number;
    affiliateIds: number[];
    withEmail: boolean;
}

export class SimpleRevokeObj {
    subChainId: number;
    withEmail: boolean;
}

export class NotifyActionTypeObj {
    id: number;
    name: string;
    description: string;
    active: boolean;
}

export class NotifyActionTypeParameterObj {
    id: number;
    notifyActionTypeId: number;
    name: string;
    description: string;
    typeName: string;
    format: string;
}

export class NotifyActionTypeUrlObj {
    name: string;
    productId: number;
    url: string;
}

export class NotifyPixelDetailObj {
    affiliate: KeyValueObj;
    pixelPerCampaign: boolean;
    campaignId: number;
    typeId: number;
    active: boolean;
    filter: FilterObj;
}

export class NotifyPixelObj {
    id: number;
    notifyPixelUrl: string;
    typeId: number;
    affiliate: KeyValueObj;
    active: boolean;
    campaignId: number;
    pixelPerCampaign: boolean;
    filter: FilterObj;
}

export class CampaignProfilePrlObj {
    id: number;
    userId: number;
    campaignName: string;
    campaignId: number;
    name: string;
    url: string;
    trafficSourceId: number;
    createdOn: Date;
    description: string;
}

export class ContactUsObj {
    name: string;
    email: string;
    phone: string;
    message: string;
    website: string;
}

export class AccountDetailObj {
    userName: string;
    languageCode: string;
    company: string;
    companyId: string;
    productOfInterestNames: string;
    sendPromotion: boolean;
    messageEmailNotifier: boolean;
    vatPayer: boolean;
    taxId: string;
    websites: IdNameMxObj[];
}

export class AddNewDocumentObj {
    content: ContentObj;
    name: string;
    description: string;
    notifyAgent: boolean;
}

export class ManagerInfoObj {
    agentEmail: string;
    firstName: string;
    lastName: string;
    msTeams: string;
    phone: string;
}

export class PortalContactObj {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    contactTypeId: number;
    contactTypeName: string;
    countryCode: string;
    state: string;
    city: string;
    address1: string;
    address2: string;
    zip: string;
    fax: string;
    msTeams: string;
    statusId: number;
}

export class CookieTemplateObj {
    id: number;
    name: string;
    template: string;
    duration: number;
    toEncode: boolean;
    productId: number;
}

export class LandingPageObj {
    id: number;
    productId: number;
    name: string;
    statusId: number;
    statusName: string;
    languageCode: string;
    languageName: string;
    typeId: number;
    typeName: string;
    creationDate: Date;
    ignoreRedirectTemplate: boolean;
    url: string;
    description: string;
    public: boolean;
    default: boolean;
}

export class NewProductObj {
    id: number;
    name: string;
    order: number;
    typeId: number;
    statusId: number;
    defaultAffiliate: KeyValueObj;
    languages: KeyValueObj;
    currencies: KeyValueObj;
    url: string;
    description: string;
}

export class ProductObj {
    id: number;
    name: string;
    order: number;
    typeId: number;
    statusId: number;
    defaultAffiliate: KeyValueObj;
    url: string;
    description: string;
}

export class AvailableReportDefObj {
    id: number;
    name: string;
}

export class BoGraphForEditObj {
    graph: GraphObj;
    allInput: ReportUiDataObj[];
    allOutput: ReportUiDataObj[];
}

export class GraphObj {
    id: number;
    name: string;
    type: string;
    reportDefId: number;
    location: string;
    valid: boolean;
    xAxis: string;
    inputs: GraphInputFieldObj[];
    outputs: GraphOutputFieldObj[];
}

export class BoGraphObj extends GraphObj {
}

export class FieldReferencedEntityObj {
    entityName: string;
    columnToKeyMap: { [index: string]: string };
    filterValue: string;
}

export class FieldReferencedReportObj {
    reportId: number;
    reportName: string;
    parametersMap: { [index: string]: string };
}

export class GraphInputFieldObj {
    id: number;
    name: string;
    value: string;
    internal: boolean;
    dynamic: boolean;
    required: boolean;
    order: number;
}

export class GraphOutputFieldObj {
    name: string;
    type: string;
    side: string;
}

export class PortalGraphObj extends GraphObj {
}

export class ReportAffiliateDialogObj {
    showAssignedFields: boolean;
    affiliate: KeyValueObj;
    campaignId: number;
}

export class ReportCellObj {
    name: string;
    value: any;
}

export class ReportDefObj {
    id: number;
    name: string;
    description: string;
}

export class ReportRequestObj {
    reportName: string;
    reportId: number;
    type: string;
    runParams: ReportRunParamsObj;
    filters: ReportUiDataObj[];
    idsToOrders: IdToOrderObj[];
    outputColumns: string[];
}

export class ReportResponseObj {
    name: string;
    id: number;
    input: ReportUiDataObj[];
    output: ReportUiDataObj[];
}

export class ReportRunParamsObj {
    affiliateId: number;
    campaignId: number;
    asAffiliate: boolean;
}

export class ReportSchedulerInputFieldObj {
    id: number;
    name: string;
    label: string;
    value: string;
    displayValue: string;
    isRequired: boolean;
}

export class ReportSchedulerObj {
    id: number;
    name: string;
    reportId: number;
    active: boolean;
    description: string;
    isAlert: boolean;
    inputFields: ReportSchedulerInputFieldObj[];
    outputFields: ReportSchedulerOutputFieldObj[];
    recipients: ReportSchedulerRecipientObj[];
    allInput: ReportUiDataObj[];
    allOutput: ReportUiDataObj[];
    scheduleType: number;
    scheduleIntervalAmount: number;
    scheduleHourInterval: number;
}

export class ReportSchedulerOutputFieldObj {
    id: number;
    name: string;
    label: string;
    order: number;
}

export class ReportSchedulerRecipientObj {
    id: number;
    userName: string;
    firstName: string;
    lastName: string;
    agentEmail: string;
    phone: string;
}

export class ReportSearchResultObj {
    cells: ReportCellObj[][];
    totalsData: { [index: string]: ReportCellObj };
    totalCount: number;
    message: string;
    partialResult: boolean;
}

export class TypedObj {
    type: string;
}

export class ReportUiDataObj extends TypedObj {
    field: string;
    label: string;
    required: boolean;
    hidden: boolean;
    value: string;
    values: string[][];
    sublist: ReportUiDataObj[];
    collapsible: boolean;
    collapsed: boolean;
    disabled: boolean;
    sortable: boolean;
    basedOnField: string;
    returnedColumn: string;
    showIf: string;
    createColumn: boolean;
    dateTimeFormat: string;
    referencedReport: FieldReferencedReportObj;
    referencedEntity: FieldReferencedEntityObj;
    filter: boolean;
    precision: number;
    isListWithParams: boolean;
    selectedIds: string;
    createSummary: boolean;
}

export class ReportUserConfigurationObj {
    reportName: string;
    configName: string;
    config: string;
}

export class ReportViewObj {
    allInput: ReportUiDataObj[];
    allOutput: ReportUiDataObj[];
    requiredInput: ReportUiDataObj[];
}

export class ScheduleObj {
    scheduleType: number;
    scheduleIntervalAmount: number;
    scheduleHourInterval: number;
}

export class BreadcrumbObj {
    type: BreadcrumbType;
    id: string;
}

export interface DynamicListDataProvider {
    listName: DynamicListName;
}

export class FieldUiDataObj {
    name: string;
    type: string;
    hidden: boolean;
    disabledOnEdit: boolean;
    disabledOnEditValues: string[];
    disabled: boolean;
    label: string;
    labelCode: string;
    dependsOn: FieldUiDynamicListObj;
    showChildDependOn: string;
    disabledDependsOnField: string;
    defaultValue: any;
    showInCompactMode: boolean;
    validation: FieldValidationObj;
    showIf: string;
    informationKey: string;
    sublist: FieldUiDataObj[];
}

export class FieldUiDataAssignmentObj extends FieldUiDataObj {
    assignmentComponent: string;
    returnedColumn: string;
    selectionMode: string;
    filter: any;
}

export class FieldUiDataComboBoxObj extends FieldUiDataObj {
    options: KeyValueObj[];
}

export class FieldUiDataDateObj extends FieldUiDataObj {
    minDate: Date;
    maxDate: Date;
}

export class FieldUiDataDateRangeObj extends FieldUiDataObj {
    fromDate: Date;
    toDate: Date;
}

export class FieldUiDataFileUploadObj extends FieldUiDataObj {
    allowedTypes: string;
}

export class FieldUiDataNumberObj extends FieldUiDataObj {
    precision: number;
    positiveInteger: boolean;
}

export class FieldUiDataPasswordObj extends FieldUiDataObj {
    retypeLabel: string;
}

export class FieldUiDataSetObj extends FieldUiDataObj {
    collapsible: boolean;
    collapsed: boolean;
}

export class FieldUiDynamicListObj {
    dependField: string;
    property: { [index: string]: string };
    optionsList: DynamicListName;
}

export class FieldValidationObj {
    required: boolean;
    minLength: number;
    maxLength: number;
    minValue: number;
    maxValue: number;
    type: ValidationType;
    pattern: ValidationRegex;
    integerDigits: number;
    fractionDigits: number;
    defaultValue: string;
}

export class KeyValueObj {
    key: any;
    value: string;
    dependOn: any;
}

export interface ListDataProvider {
    listName: ListName;
    data: KeyValueObj[];
}

export class UiDataObj {
    asyncValidation: boolean;
    describeOfObj: string;
    fieldsData: FieldUiDataObj[];
}

export class DeleteValidationResponseObj {
    message: string;
    allowDelete: boolean;
}

export class FieldErrorObj {
    code: string;
    message: string;
}

export class GlobalErrorObj {
    code: string;
    message: string;
}

export class ValidationResponseObj {
    globalErrors: GlobalErrorObj[];
    fieldErrors: { [index: string]: FieldErrorObj[] };
}

export class InvocationCodeObj {
    zoneId: number;
    affiliate: KeyValueObj;
    campaign: number;
    profile: number;
    type: number;
    action: number;
    landingPage: number;
    var1: string;
    var2: string;
    var3: string;
    var4: string;
    var5: string;
    var6: string;
    var7: string;
    var8: string;
    var9: string;
    var10: string;
}

export class MassAffiliateInvocationCodeObj {
    zoneId: number[];
    affiliate: KeyValueObj;
    campaign: number;
    profile: number;
    type: number;
    action: number;
}

export class MassInvocationCodeObj {
    zoneId: number;
    affiliatesFile: any;
    type: number;
    action: number;
    landingPage: number;
}

export class SetCreativesWeightObj {
    zoneId: number;
    ids: number[];
    weight: number;
}

export class ZoneCreativeObj {
    id: number;
    name: string;
    weight: number;
    type: string;
    subType: string;
    language: string;
    currency: string;
    promotionType: string;
    productName: string;
    status: string;
    isDefaultInZone: boolean;
    description: string;
    hasThumb: boolean;
    url: string;
    height: number;
    width: number;
    editorType: string;
    filters: KeyValueObj[];
    productId: number;
    merchantId: number;
}

export class ZoneCreativesObj {
    creatives: ZoneCreativeObj[];
}

export class ZoneObj {
    id: number;
    name: string;
    creativeTypeId: number;
    creativeSubTypeId: number;
    campaignId: number;
    statusId: number;
    affiliate: KeyValueObj;
    description: string;
    defaultCreative: KeyValueObj;
}

export class AffiliateBalanceListMxObj {
    data: AffiliateBalanceMxObj[];
}

export class GeneralObj implements Serializable {
}

export class AffiliateBalanceMxObj extends GeneralObj {
    openingBalance: number;
    openingBalanceRounded: number;
    liabilities: number;
    endingBalanceRounded: number;
    endingBalance: number;
    isAffiliatePayable: boolean;
    merchantId: number;
    merchantName: string;
}

export class GraphInputMxObj implements Serializable {
    graphId: number;
    input: ReportFieldMxObj[];
    language: string;
    campaignId: number;
}

export class IdNameMxObj extends GeneralObj implements Comparable<IdNameMxObj> {
    id: string;
    name: string;
}

export class InvocationCodeParamsMxObj extends GeneralObj {
    type: InvocationCodeType;
    zoneId: number;
    landingPageId: number;
    profileId: number;
    promoId: number;
    var1: string;
    var2: string;
    var3: string;
    var4: string;
    var5: string;
    var6: string;
    var7: string;
    var8: string;
    var9: string;
    var10: string;
}

export class InvocationCodeResultMxObj extends GeneralObj {
    value: string;
    userVarsEnabled: boolean;
}

export class OrderedIdNameMxObj extends IdNameMxObj {
    order: number;
}

export class PromoLightMxObj {
    id: number;
    thumbContent: string;
    typeName: string;
}

export class PromoMxObj extends PromoLightMxObj {
    name: string;
    subTypeName: string;
    description: string;
    productName: string;
    languageCode: string;
    content: string;
    currencyCode: string;
    height: number;
    width: number;
    editorTypeId: number;
    fileType: string;
    basedPromoId: number;
    hasContent: boolean;
    textBased: boolean;
}

export class ReportMxObj {
    id: number;
    name: string;
    campaignId: number;
    input: ReportFieldMxObj[];
    output: ReportFieldMxObj[];
    language: string;
}

export class TableMxObj {
    headers: HeaderObj[];
    values: StringListBean[];
    total: StringListBean;
    partialData: boolean;
    message: string;
    headerTitles: string[];
}

export class TopZoneMxObj {
    zoneId: number;
    promo: PromoLightMxObj;
    promos: PromoLightMxObj[];
    description: string;
}

export class ValidationDataMxObj {
    validators: { [P in ValidationType]?: Validator };
    regexes: { [P in ValidationRegex]?: RegexTypeInfo };
}

export interface Serializable {
}

export class HeaderObj extends GeneralObj {
    column: string;
    title: string;
}

export class StringListBean {
    data: string[];
}

export class Validatable implements Serializable {
    minLength: number;
    maxLength: number;
    mandatory: boolean;
    regexName: ValidationRegex;
}

export class Validator extends Validatable implements Serializable {
    validators: Validator[];
    name: ValidationType;
    message: string;
    messageCode: string;
    externalValidation: boolean;
    conditionalMandatory: boolean;
}

export class RegexTypeInfo implements Serializable {
    regexName: ValidationRegex;
    regex: string;
    message: string;
    messageCode: string;
}

export interface Comparable<T> {
}

export type FilterOperator = "EQUALS" | "DOES_NOT_EQUAL" | "IS_BLANK" | "IS_NOT_BLANK" | "IS_ANY_OF" | "IS_NONE_OF" | "IS_LIKE" | "IS_NOT_LIKE" | "IS_GREATER_THAN" | "IS_GREATER_THAN_OR_EQUAL_TO" | "IS_LESS_THAN" | "IS_LESS_THAN_OR_EQUAL_TO" | "IS_BETWEEN" | "IS_NOT_BETWEEN" | "CONTAINS" | "DOES_NOT_CONTAIN" | "BEGINS_WITH" | "ENDS_WITH";

export type JobStatus = "INITIAL" | "RUNNING" | "CANCELED" | "FINISHED" | "ERROR" | "UNKNOWN";

export type DynamicListName = "NONE" | "CREATIVE_SUB_TYPE" | "GRAPH_TYPE" | "ACTIVE_CAMPAIGN" | "PROFILE" | "LANDING_PAGE" | "PRODUCT_LANGUAGES" | "PRODUCT_CURRENCIES" | "MERCHANT_CAMPAIGNS" | "PRL_PROFILE_CAMPAIGN" | "PAYMENT_ACCOUNT";

export type FieldType = "ASSIGNMENT" | "AUTO" | "CHECKBOX" | "COLORPICKER" | "DATEPICKER" | "DATERANGE" | "DATETIME" | "DROPDOWN" | "FILEUPLOAD" | "GROUP" | "HTMLBOX" | "NUMERIC" | "PASSWORD" | "PAYMENT_ACCOUNT" | "PERMISSIONS" | "TEXTAREA" | "TEXTBOX";

export type ListName = "NONE" | "RERUN_REQUEST_TYPE" | "TAX_TYPE" | "PRODUCT_TYPE" | "COUNTRY" | "LANGUAGE" | "EMAIL_TEMPLATE" | "CREATIVE_TYPE" | "CREATIVE_TYPE_TEMPLATE" | "CREATIVE_TAG_TYPE" | "COLOR_TAG_TYPE" | "AFFILIATE_TAG_TYPE" | "STATUS" | "PAYMENT_STATUS" | "PAYMENT_METHOD" | "ALL_PAYMENT_METHOD" | "INVOCATION_CODE_TYPE" | "INVOCATION_CODE_ACTION" | "PRODUCT" | "ACTIVE_PRODUCT" | "PORTAL_LANGUAGE" | "BO_REPORT" | "PORTAL_REPORT" | "BO_GRAPH_LOCATION" | "GRAPH_TYPE" | "TRACKER" | "CONTACT_TYPE" | "TRAFFIC_SOURCE" | "FORMULA" | "LANDING_PAGE_TYPE" | "PROMOTION_TYPE" | "AGENT" | "PAYING_COMPANY" | "NON_CLOSED_TRANSACTION_PERIOD" | "TRANSACTION_STATUS" | "TRANSACTION_TYPE" | "TRANSACTION_PERIOD" | "SCHEDULE_TYPE" | "SCHEDULE_HOURS" | "MESSAGE_TYPES" | "MAILING_LIST_TYPE" | "ACTIVE_NOTIFY_ACTION_TYPE" | "NOTIFY_ACTION_TYPE_PARAMETER_TYPE" | "NOTIFY_ACTION_TYPE_PARAMETER_DATE_FORMAT" | "DEAL_PRESET_TYPES" | "PRL_TRAFFIC_SOURCE" | "CONTACT_TYPES";

export type BreadcrumbType = "MERCHANT" | "PRODUCT" | "CREATIVE" | "AFFILIATE" | "CAMPAIGN" | "LANDING_PAGE" | "DEAL" | "ZONE" | "DEAL_PRESET" | "FIELD_PRESET" | "REPORT" | "GRAPH" | "PORTAL_GRAPH" | "REPORT_SCHEDULER" | "ROTATION_ZONE_FILTER" | "NOTIFY_PIXELS" | "NOTIFY_ACTION_TYPE" | "AGENT" | "ROLE" | "TEAM" | "PROMO_TYPE" | "CREATIVE_TYPE" | "TRAFFIC_SOURCE" | "PRODUCT_TYPE" | "PAYING_COMPANY" | "AFFILIATE_TAG" | "COLOR_TAG" | "CREATIVE_TAG" | "INVOCATION_CODE_TEMPLATE" | "EMAIL_TEMPLATE" | "OTHER_TEMPLATE" | "PORTAL_NOTIFICATION" | "PORTAL_LABEL_CONTENT" | "PORTAL_DESIGN_LABEL";

export type DataRetentionType = "AFFILIATE" | "AGENT" | "MERCHANT" | "PRODUCT";

export type DateRange = "CUSTOM" | "TODAY" | "YESTERDAY" | "CURRWEEK" | "PREV7DAYS" | "PREVWEEK" | "CURRMONTH" | "PREV30DAYS" | "PREVMONTH" | "THREEMONTHS" | "PREV90DAYS" | "SIXMONTHS" | "PREV180DAYS" | "CURRYEAR" | "PREV365DAYS" | "PREVYEAR";

export type MessageTypes = "GLOBAL" | "REGULAR";

export type PropertyType = "APPLICATION_PROPERTY" | "CONFIGURATION_PROPERTY";

export type TransactionActionType = "DECLINE" | "REQUEST" | "APPROVE" | "CLOSE_MONTH" | "APPROVE_ALL" | "UPDATE" | "HOLD" | "FINAL_APPROVE" | "WITHDRAWAL_REQUEST_APPROVE";

export type TransactionSearchTypeStatus = "PUBLIC" | "INTERNAL";

export type TransactionType = "INSERT" | "UPDATE" | "DELETE";

export type TrxType = "EARNING" | "BONUS" | "CORRECTION" | "WITHDRAWAL" | "ADVANCE" | "PREPAID" | "BALANCE_UPDATE" | "FEE" | "LIABILITIES_CORRECTION" | "LIABILITIES_INITIALIZATION" | "SUB_AFFILIATION_EARNING" | "RETURN_ADVANCE" | "RETURN_WITHDRAWAL" | "REFUND" | "SPECIAL_WITHDRAWAL";

export type AvailableAction = "VIEW" | "EDIT" | "DELETE" | "ADD";

export type VariableType = "STRING" | "NUMBER" | "DATE" | "TIME" | "DATETIME" | "MAP_STRING" | "LIST" | "TAG" | "ADV_TAG" | "TEMPLATE";

export type EarningProcessMonthlyStatus = "ERROR" | "FAILED" | "IN_PROCESS" | "DONE" | "START" | "BEFORE_TIME" | "WARNINGS_NOT_CLOSED" | "NOT_ALL_FILES_LOADED" | "WARNINGS_AND_FILES_PROBLEMS" | "DAILY_STATS_NOT_FINISHED" | "DEAL_CALC_NOT_FINISHED";

export type ValidationType = "NONE" | "URL" | "LANDING_URL" | "AUTHORIZED_URL" | "TEMPLATE_URL" | "SIGNUP_URL" | "USERNAME" | "USERNAME_PATTERN" | "NEW_USERNAME_BO" | "NEW_USERNAME_PORTAL" | "OLD_PASSWORD" | "PASSWORD" | "NAME" | "EMAIL" | "ADDRESS" | "PHONE" | "DESCRIPTION" | "MESSAGE_TEXT" | "STATE" | "CITY" | "ZIP" | "MS_TEAMS" | "VERSION" | "BOOLEAN" | "PROFILE_NAME" | "COUNTRY_AND_STATE" | "COUNTRY_CODE" | "PROFILE_AND_CAMPAIGN_ID" | "EXISTING_COUNTRY" | "EXISTING_LANGUAGE" | "PRODUCTS_OF_INTEREST" | "WITHDRAWAL_REQUEST_AMOUNT" | "IDENTIFICATION_NUMBER" | "VAT_NUMBER" | "PAYMENT_REQUEST_DESCRIPTION" | "WEBMONEY_ACCOUNT_NUMBER" | "PAYMENT_ACCOUNT_EMAIL" | "NETELLER_ACCOUNT_ID" | "QIWI_PHONE_NUMBER" | "NETELLER_SECURE_ID" | "BANK_CODE" | "OWNER_MANDATORY_IF_NORMAL" | "CRYPTO_WALLET" | "COMPANY_ID" | "TAX_ID" | "PROVINCE" | "POSTAL_CODE" | "BRANCH_CODE";

export type ValidationRegex = "SQL_IDENTIFIER" | "CHARACTERS_AND_DIGITS_ONLY" | "CHARACTERS_AND_DIGITS_AND_SPECIAL" | "CHARACTERS_AND_DIGITS_AND_UNDERSCORE_AND_MINUS" | "CHARACTERS_AND_DIGITS_ONLY_WITH_SPACE_FOR_SEARCH" | "CHARACTERS_AND_DIGITS_ONLY_WITH_SPACE" | "CHARACTERS_AND_DIGITS_ONLY_WITH_SPACE_AND_UNDER_LINE" | "ADDRESS" | "PT_PASSWORD" | "AGENT_PHONE" | "CHARACTERS_ONLY_WITHOUT_SPACE_FOR_SEARCH" | "DIGITS_12_WITH_3_DIGITS_AFTER_DECIMAL_POINT" | "DIGITS_12_WITH_3_DIGITS_AFTER_DECIMAL_POINT_WITH_MINUS" | "DIGITS_12_WITH_2_DIGITS_AFTER_DECIMAL_POINT_WITH_MINUS" | "CONTACT_PHONE" | "COST_PER_UNIT" | "COUNT" | "CHARACTERS_ONLY_WITH_SPACE" | "DESCRIPTION" | "NAME" | "NAME_SEARCH" | "TRIMED_STRING" | "TRIMMED_STRING_WITHOUT_SEMICOLON" | "WITHOUT_SEMICOLON" | "NOT_CONTAINS_WHITESPACE_CHARACTER" | "DIGITS_ONLY" | "MS_TEAMS" | "CHARACTERS_AND_DIGITS_ONLY_WITH_UNDER_LINE_FOR_SEARCH" | "CHARACTERS_ONLY_WITH_UNDER_LINE" | "VERSION" | "DIGITS_BETWEEN_0_TO_99" | "WEIGHT_2" | "WEIGHT" | "ZIP" | "URL" | "AUTHORIZED_URL" | "TEMPLATE_URL" | "BOOLEAN" | "DEAL_TYPE" | "GENERAL_PAYMENT_ACCOUNT" | "NUMBER_BETWEEN_1_TO_10" | "NUMBER_BETWEEN_1_TO_99" | "NUMBER_BETWEEN_1_TO_100" | "LIST_OF_LETTERS_AND_DIGITS" | "START_WITH_LETTERS_OR_DIGITS" | "TAG_TYPE_AND_TAG" | "PAYMENT_STATUS" | "TRIMMED_STRING_WITHOUT_COLON" | "DIGITS_3_WITH_2_DIGITS_AFTER_DECIMAL_POINT" | "DIGITS_ONLY_STARTING_NOT_WITH_ZERO" | "WEBMONEY_ACCOUNT_NUMBER" | "PAYMENT_ACCOUNT_EMAIL" | "NETELLER_ACCOUNT_ID" | "QIWI_PHONE_NUMBER" | "NETELLER_SECURE_ID" | "TRANSACTION_TYPE" | "CRYPTO_WALLET" | "TAX_ID" | "WIRE_TRANSFER_TYPE";

export type InvocationCodeType = "HTML" | "JS";

export type FilterNodeObjUnion = RuleNodeObj | GroupNodeObj | EmptyNodeObj;
